function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Row-Menu",
  transform: "translate(-248.000000, -114.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Text-Banner",
  transform: "translate(248.000000, 114.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#CDD4DA",
  x: 0,
  y: 14,
  width: 160,
  height: 80
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon/Text/M/Default",
  transform: "translate(68.000000, 42.000000)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#000000",
  fillRule: "nonzero",
  opacity: 0,
  x: 0,
  y: 0,
  width: 24,
  height: 24
}), /*#__PURE__*/React.createElement("path", {
  d: "M20,4 L4,4 C3.44771525,4 3,4.44771525 3,5 L3,8 C3,8.55228475 3.44771525,9 4,9 C4.55228475,9 5,8.55228475 5,8 L5,6 L11,6 L11,19 L9,19 C8.44771525,19 8,19.4477153 8,20 C8,20.5522847 8.44771525,21 9,21 L15,21 C15.5522847,21 16,20.5522847 16,20 C16,19.4477153 15.5522847,19 15,19 L13,19 L13,6 L19,6 L19,8 C19,8.55228475 19.4477153,9 20,9 C20.5522847,9 21,8.55228475 21,8 L21,5 C21,4.44771525 20.5522847,4 20,4 Z",
  id: "Path",
  fill: "#000000",
  fillRule: "nonzero"
}))), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  stroke: "#8C9BA8",
  x: 0.5,
  y: 14.5,
  width: 159,
  height: 79
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  stroke: "#CDD4DA",
  x: 0.5,
  y: 0.5,
  width: 159,
  height: 107
}))));

function SvgIconTextBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "160px",
    height: "108px",
    viewBox: "0 0 160 108",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTextBanner);
export default __webpack_public_path__ + "static/media/icon_text_banner.1587e695.svg";
export { ForwardRef as ReactComponent };